import es from "hyphenated-es";
import React from "react";
import Hyphenated from "react-hyphen";
import imgAuth from "../../../assets/img/autorizacion.png";
import { useLanguage } from "../../../hooks/useLanguage";

export default () => {
  const { benefits: language } = useLanguage();

  return (
    <div className="w-full flex flex-col items-center bg-ngray-300">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 max-w-9xl">
        <div className="w-full flex flex-col items-stretch px-8 xl:px-20 justify-center order-2 lg:order-1">
          <img className="object-contain" src={imgAuth} />
        </div>
        <div className="w-full flex flex-col items-right px-8 xl:px-20 justify-center my-12 md:my-20 text-center lg:text-right order-1 lg:order-2">
          <h2 className="w-full leading-normal text-primary-700 text-4xl md:text-5xl font-normal mb-8">
            {language.authTitle}
          </h2>
          <p className="text-primary-700 text-lg md:text-xl md:leading-loose md:pl-8">
            <Hyphenated language={es}>{language.authText}</Hyphenated>
          </p>
        </div>
      </div>
    </div>
  );
};
